import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ isAdmin = false }) => {
  const user = useSelector((state) => state.auth.user);

  console.log(user);
  if (!user) return <Navigate to="/login" />;

  if (isAdmin && !user.isAdmin) return <Navigate to="/" />;

  return <Outlet />;
};

export default ProtectedRoute;
